import React, { useEffect, useState } from 'react';
import { getBackendVersion } from '../api/Version';
import { FormattedMessage } from 'react-intl';
import { REPORTSTATUS } from '../util/DataModelInterface';
import useToastHandler from '../hooks/useToastHandler';
import { DataTable } from './DataTable';
import { actionButtons } from './ActionButtons';
import { calendarDateView, getDeadline, getPeriodString } from '../util/FormatDateUtil';

/**
 * Gets the app name and version from package.json via .env file
 * Gets the backend version from the API
 */
 export const Version = (intl: any) => {
  const { addToast } = useToastHandler();
  const [version, setVersion] = useState("");

  useEffect(() => {

    async function fetchVersion() {
      let version = await getBackendVersion();
      if (version?.error) {
        addToast(version.error, 'terms', 'fetch');
      } else {
        // console.log("useEffect(), version here", version);
        setVersion(version ? version : "");
      }
    }

    fetchVersion()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <> v{process.env.REACT_APP_VERSION} {version}</>
}

/**
 * Report status view
 */
export const statusView = (status: string, deadline: Date, forceRed: boolean = false) => {
  let icon = status === REPORTSTATUS.CONFIRMED || status === REPORTSTATUS.CORRECTED || 
             status === REPORTSTATUS.BILLED || status === REPORTSTATUS.REBILLED || status === "MISSING"  ? 'fa-check' : 'fa-spinner';
  let today = new Date();
  let classes = '';
  if( (today >= deadline && (status === REPORTSTATUS.NEW || status === REPORTSTATUS.ONGOING || status === REPORTSTATUS.REOPENED)) ||
      status === 'EDITING' || forceRed ) {
        classes += 'error';
      }
  if (today >= deadline && status === REPORTSTATUS.NEW) {
    status = "OVERDUE";
    icon = 'fa-exclamation-triangle';
  }
  return (
    <>
      <span className={classes} ><i className={"me-2 fa " + icon}/></span>
      <span className={classes} ><FormattedMessage id={'reportstatus.' + status}/></span>
    </>
  );
}

/**
 * Billing status view
 */
export const billingStatusView = (status: string) => {
  let icon = status === REPORTSTATUS.BILLED || status === REPORTSTATUS.REBILLED ? 'fa-check' : 'fa-spinner';
  return <span><i className={"me-2 fa " + icon}/><FormattedMessage id={'billingstatus.' + status}/></span>;
}


/**
 * Period view
 */
export const periodView = (period: string, interval: string | undefined) => {
  if (interval && parseInt(interval) > 1) {
    return <span>{period}<button disabled className="btn-label" ><span>{interval}<FormattedMessage id='reports.intervalShort'/></span></button></span>;
  }
  return period;
}

/**
 * Data format for report list table
 */
interface IReportTableData {
  company: string | undefined,
  period: string,
  periodView: JSX.Element | string,
  deadline: JSX.Element,
  state: JSX.Element,
  lastmodified: JSX.Element,
  id: string,
  status: string,
  companyId: string,
  periodTimestamp: string,
  actions: JSX.Element
}

/**
 * Table data for report list view
 */
const tableData = (name: string, reports: any[]) => {
  let data = [] as IReportTableData[];
  reports.forEach((r, i) => {
    let date = new Date(r.period);
    let period = getPeriodString(date);
    let monthStr = period.split("-")[1];
    let yearStr = period.split("-")[0];
    let reportingPeriod = monthStr + "/" + yearStr;
    data[i] = {
      company: name,
      period: reportingPeriod,
      periodView: periodView(reportingPeriod, r.report_interval),
      deadline: calendarDateView(getDeadline(date)),
      lastmodified: calendarDateView(new Date(r.modified ? r.modified : r.created)),
      state: statusView(r.status, getDeadline(date)),
      id: r.report_id,
      status: r.status,
      companyId: r.company,
      periodTimestamp: period,
      actions: actionButtons(r.company, name ? name : '', period, r.status, '/reports/report', true),
    };
  });
  data.sort((a: any, b: any) => 
    {
      return new Date(b.periodTimestamp).getTime() - new Date(a.periodTimestamp).getTime()
    });
  return data;
}

/**
 * Reportlist view for a company
 */
export const reportListView = (name: string, reports: any[]) => {
  return(
    <div id="reportlist">
      <DataTable tableheadings={['periodView', 'deadline', 'lastmodified', 'state', 'actions']}
                tabledata={tableData(name, reports)} caption={'reports.tablecaption'}
                tableType='reports' tableId='reportlist'
                optSortableColumns={['periodView', 'state']}
                hiddenColumns={['period']}
                />
    </div>);
}